import { IPatientProfilePage } from './_types';
import { Invoices, PersonalInformation } from './pages';

/** Sidebar tabs — the URL is /access/patients/:id/<slug>. */
export const SIDEBAR_OPTIONS: IPatientProfilePage[] = [
  {
    slug: 'personal-information',
    name: 'Personal Information',
    component: PersonalInformation
  },
  {
    slug: 'invoices',
    name: 'Invoices',
    component: Invoices
  }
];

export const DEFAULT_PAGE = SIDEBAR_OPTIONS[0].slug;
